module.exports = fox._r("images/photo-placeholder.gif", __webpack_public_path__ + "_/_/_/root/images/photo-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/photo-placeholder.gif
// module id = 737
// module chunks = 4